<template>
  <div id="basic">
    <el-dialog title="补充营收数据" :visible.sync="dialogRevenueVisible" width="60%">
      <el-form :model="revenueForm" :rules="rules" ref="revenueForm" label-width="150px" style="width: 50%">
        <el-form-item label="业务日期"  prop="date">
          <el-date-picker
            v-model="revenueForm.date"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            style="width: 400px"
          >
        </el-date-picker>
        </el-form-item>

        <el-form-item label="营收项目名称"  prop="name">
          <el-input v-model="revenueForm.name" style="width: 400px">
          </el-input>
        </el-form-item>

        <el-form-item label="营收金额"  prop="amount">
          <el-input v-model="revenueForm.amount"  type="number" style="width: 400px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <div style="margin-left: 50px; margin-bottom: 20px; font-size: 12px; color: #31a6ba; width: 500px">
                  备注:补充营收数据为非平台结算数据,比如外卖单, 团餐, 月结客户, 请谨慎填写
        </div>
      </el-form>
      <el-button type="primary" @click="onSubmitRevenue" style="margin-left: 150px">确 定</el-button>

<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="dialogRevenueVisible = false">取 消</el-button>-->
<!--      </div>-->
    </el-dialog>

    <el-dialog title="补充营收数据详情" :visible.sync="dialogRevenueDetailVisible" width="60%">
      <el-form :model="revenueDetailForm" :rules="rules" ref="revenueDetailForm" label-width="150px" style="width: 100%">

        <el-table
            :fit="false"
            border
            :data="tableData"
            :cell-style="() => 'text-align: center;'"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
        >
          <template slot="empty">
            <noCart></noCart>
          </template>
          <el-table-column label="营收项目" width="500px">
            <template slot-scope="scope">
              <span>{{ scope.row.item }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" width="250">
            <template slot-scope="scope">
              <span>{{ scope.row.day }}</span>
            </template>
          </el-table-column>
          <el-table-column label="营收金额" width="250">
            <template slot-scope="scope">
              <span>{{ scope.row.price/100.0 }} 元</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-form>
    </el-dialog>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="istopflex" style="display: flex; margin-bottom: 20px">
          <div style="display: flex">
            <div style="margin-right: 20px; line-height: 37px">选择门店：</div>
            <el-select
              v-model="formInline.id"
              placeholder="请选择"
              @change="getList"
            >
              <el-option
                v-for="index in typeDate"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="12"
        ><div class="grid-content purple_a">
          <div class="top_item_s">
            <div class="item_value_s">
              {{ topValue['total_sale_day_' + getDate(true)] || 0 }}
            </div>
            <div class="item_name_s">经营额</div>
            <!-- <div class="item_click_s">
              查看详细
              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="12"
        ><div class="grid-content purple_b">
          <div class="top_item_s">
            <div class="item_value_s">
              {{ topValue['client_stat_day_' + getDate(true)] || 0 }}
            </div>
            <div class="item_name_s">客户量</div>
            <!-- <div class="item_click_s">
              查看详细

              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="12"
        ><div class="grid-content purple_c">
          <div class="top_item_s">
            <div class="item_value_s">
              {{ topValue['per_client_sale_day_' + getDate(true)] || 0 }}
            </div>
            <div class="item_name_s">客均单价</div>
            <!-- <div class="item_click_s">
              查看详细

              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="12"
        ><div class="grid-content purple_d">
          <div class="top_item_s">
            <div class="item_value_s">
              {{ topValue['prepay_sale_day_' + getDate(true)] || 0 }}
            </div>
            <div class="item_name_s">充值金额</div>
            <!-- <div class="item_click_s">
              查看详细

              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item title="营收数据统计" name="1">
              <el-row :gutter="20">
                <el-col :lg="16" :md="24">
                  <div class="back_s">
                    <div id="echart_A" style="width: 100%; height: 300px"></div>
                  </div>
                </el-col>
                <el-col :lg="8" :md="24">
                  <div class="back_s">
                    <div class="back_s_name" style="display: flex">
                      <div>收款通道汇总数据</div>
                      <el-button type="primary" size="mini" round style="margin-left: 20px" @click="additionalRevenue">+ 补充营收数据</el-button>
                      <el-button type="primary" size="mini" round style="margin-left: 20px" @click="showAdditionalRevenue">查看补充营收</el-button>
                    </div>

                    <div class="flex_center">
                      <div class="name_flex">
                        <div>微信支付</div>
                        <div>
                          {{
                            topValue['wechat_sale_month_' + getDate()] || 0
                          }}/{{ total }}
                        </div>
                      </div>
                      <el-progress
                        text-inside
                        :show-text="false"
                        :percentage="
                          Math.round(
                            ((topValue['wechat_sale_month_' + getDate()] || 0) /
                              total) *
                              10000
                          ) / 100.0
                        "
                        :color="'#26a941'"
                      ></el-progress>
                    </div>
                    <div class="flex_center">
                      <div class="name_flex">
                        <div>支付宝支付</div>
                        <div>
                          {{ topValue['ali_sale_month_' + getDate()] || 0 }}/{{
                            total
                          }}
                        </div>
                      </div>
                      <el-progress
                        text-inside
                        :show-text="false"
                        :percentage="
                          Math.round(
                            ((topValue['ali_sale_month_' + getDate()] || 0) /
                              total) *
                              10000
                          ) / 100.0
                        "
                        :color="'#007aff'"
                      ></el-progress>
                    </div>
                    <div class="flex_center">
                      <div class="name_flex">
                        <div>会员支付</div>
                        <div>
                          {{
                            topValue['member_sale_month_' + getDate()] || 0
                          }}/{{ total }}
                        </div>
                      </div>
                      <el-progress
                        text-inside
                        :show-text="false"
                        :percentage="
                          Math.round(
                            ((topValue['member_sale_month_' + getDate()] || 0) /
                              total) *
                              10000
                          ) / 100.0
                        "
                        :color="'#fec202'"
                      ></el-progress>
                    </div>

                    <div class="flex_center">
                      <div class="name_flex">
                        <div>补充营收</div>
                        <div>
                          {{
                            topValue['added_sale_month_' + getDate()] || 0
                          }}/{{ total }}
                        </div>
                      </div>
                      <el-progress
                          text-inside
                          :show-text="false"
                          :percentage="
                          Math.round(
                            ((topValue['added_sale_month_' + getDate()] || 0) /
                              total) *
                              10000
                          ) / 100.0
                        "
                      ></el-progress>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <div class="shujuflex">
            <div class="shujuflex_page">
              <div class="shujuflex_a">
                {
                <i
                  :class="
                    (topValue['total_sale_month_' + getDate()] || 0) -
                      (topValue['total_sale_month_' + getDate()] || 0) >
                      0 || 'el-icon-caret-top'
                  "
                ></i>
                {{
                  Math.round(
                    (((topValue['total_sale_month_' + getDate()] || 0) -
                      (topValue['total_sale_month_' + fastDate()] || 0)) /
                      (topValue['total_sale_month_' + fastDate()] || 0)) *
                      100
                  )
                }}%
              </div>
              <div class="shujuflex_b">
                ￥{{ topValue['total_sale_month_' + getDate()] || 0 }}
              </div>
              <div class="shujuflex_c">本月营业额</div>
            </div>
            <div class="shujuflex_page">
              <div class="shujuflex_a">
                <i class="el-icon-caret-top"></i>
                {{
                  Math.round(
                    (((topValue['order_stat_month_' + getDate()] || 0) -
                      (topValue['order_stat_month_' + fastDate()] || 0)) /
                      (topValue['order_stat_month_' + fastDate()] || 0)) *
                      100
                  )
                }}%
              </div>
              <div class="shujuflex_b">
                {{ topValue['order_stat_month_' + getDate()] || 0 }}
              </div>
              <div class="shujuflex_c">本月订单量</div>
            </div>
            <div class="shujuflex_page">
              <div class="shujuflex_a">
                <i class="el-icon-caret-top"></i>
                {{
                  Math.round(
                    (((topValue['client_stat_month_' + getDate()] || 0) -
                      (topValue['client_stat_month_' + fastDate()] || 0)) /
                      (topValue['client_stat_month_' + fastDate()] || 0)) *
                      100
                  )
                }}%
              </div>
              <div class="shujuflex_b">
                {{ topValue['client_stat_month_' + getDate()] || 0 }}
              </div>
              <div class="shujuflex_c">本月客流量</div>
            </div>
            <div class="shujuflex_page">
              <div class="shujuflex_a">
                <i class="el-icon-caret-top"></i>
                10.11%
              </div>
              <div class="shujuflex_b">
                {{ topValue['prepay_sale_month_' + getDate()] || 0 }}
              </div>
              <div class="shujuflex_c">本月累计充值</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :lg="16" :md="24">
        <div class="back" style="margin-bottom: 10px">
          <el-collapse v-model="activeNamess" @change="handleChange">
            <el-collapse-item title="客流量统计" name="2">
              <div class="back_s" style="padding-bottom: 0px">
                <div id="echart_S" style="width: 100%; height: 300px"></div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      <el-col :lg="8" :md="24">
        <div class="right_valur">
          <i class="el-icon-s-finance leftIcon"></i>
          <div class="right_valur_name">
            <div>会员余额</div>
            <div>
              ￥{{
                topValue['member_total_balance_accumulate_' + getDate()] || 0
              }}
            </div>
          </div>
        </div>
        <div class="right_valur" style="background: #27a844">
          <i class="el-icon-user-solid leftIcon"></i>
          <div class="right_valur_name">
            <div>会员数量</div>
            <div>
              {{ topValue['member_stat_accumulate_' + getDate()] || 0 }}
            </div>
          </div>
        </div>
        <div class="right_valur" style="background: #dc3546">
          <i class="el-icon-s-shop leftIcon"></i>
          <div class="right_valur_name">
            <div>累计订单数量</div>
            <div>{{ topValue['order_stat_accumulate_' + getDate()] || 0 }}</div>
          </div>
        </div>
        <div class="right_valur" style="background: #17a2b7">
          <i class="el-icon-s-marketing leftIcon"></i>
          <div class="right_valur_name">
            <div>菜品数据库</div>
            <div>{{ topValue['dish_stat_accumulate_' + getDate()] || 0 }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'employee',
  data() {
    return {
      tableData:[],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      activeNames: '1',
      activeNamess: '2',
      formInline: {
        user: '',
        region: '',
        id: '',
        category_type: 1, // c_type|| 2外卖  1堂食
        date: null,
      },
      datalist: [],
      topValue: {},
      typeDate: [],
      total: 0,
      revenueForm: {},
      dialogRevenueVisible: false,
      dialogRevenueDetailVisible: false,
      rules:{
        name: [
          {required: true, message: '请输入营收项目名称', trigger: 'blur'},
        ],
        date: [
          {required: true, message: '请输入业务日期', trigger: 'blur'},
        ],
        amount: [
          {required: true, message: '请输入营收金额', trigger: 'blur'},
        ],
      },
    };
  },
  created() {
    this.$root.headName = ['运营数据', '实时概况'];
  },
  mounted() {
    this.getType();
    //
  },
  methods: {
    handleEdit(index, row) {
      console.log(index)
      console.log(row)
    },
    handleDelete(index, row) {
      this.$confirm(`确认删除该补充收益记录？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then( () => {
            const url = this.$userList.delete_revenue + `?id=` + row.id
            this.$http.delete(url).then(res =>{
              if (res.code === 200) {
                console.log(res)
                this.getRevenue(this.getMonth(true))
                this.$alert("删除成功")
              }
            })
      })
    },
    onSubmitRevenue(){
      this.$refs['revenueForm'].validate((valid) =>{
        if (valid) {
          let url = this.$userList.add_revenue
          let data = {
            shopId: this.formInline.id,
            item: this.revenueForm.name,
            price:  parseInt(this.revenueForm.amount * 100),
            day: moment(this.revenueForm.date).format("YYYY-MM-DD"),
            month: moment(this.revenueForm.date).format("YYYY-MM")
          }
          this.$http.post(url, data).then((res) => {
            if (res.code === 200) {
              this.dialogRevenueVisible = false
              this.getList()
              this.$alert('添加成功')
            }
          });
        } else {
          return false
        }
      })
    },
    additionalRevenue() {
      this.dialogRevenueVisible = true
      this.revenueForm = {}
    },
    showAdditionalRevenue() {
      this.dialogRevenueDetailVisible = true
      this.getRevenue(this.getMonth(true))
    },
    getRevenue(month) {
      const url = this.$userList.search_revenue + `/` + month + '/' + this.formInline.id;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
            console.log(res)
          this.tableData = res.data
        }
      })
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.formInline.date = [this.fastDate(true), this.getDate(true)];
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    drawLine() {
      let elementById = document.getElementById('echart_A');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
        value = [];
      const exlist = this.topValue['total_sale_day'];

      if (exlist) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.total_price / 100);
        });
      }

      let option = {
        color: ['#41ec82'],
        title: {
          text: '营收数据' + ':' + this.getDate() + '月',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        legend: {
          data: ['Line 1'],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: data,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '当日营收：',
            type: 'line',
            stack: '总量',
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: 'top',
            },
            areaStyle: {
              opacity: 0.8,
            },
            emphasis: {
              focus: 'series',
            },
            data: value,
          },
        ],
      };
      echartsDemo.setOption(option);
    },
    drawLines() {
      let elementById = document.getElementById('echart_S');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
        value = [],
        datas = [],
        values = [];
      const exlist = this.topValue['client_stat_day'];
      const exlists = this.topValue['member_stat_day'];
      if (exlist && exlist.length > 0) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.count);
        });
      }
      if (exlists && exlists.length > 0) {
        exlists.map((item) => {
          datas.push(item.day);
          values.push(item.count);
        });
      }

      let option = {
        color: ['#d2d6df', '#4f98c3'],
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['就餐人数', '会员数量'],
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: data,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '就餐人数',
            type: 'bar',
            data: value,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' },
              ],
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }],
            },
          },
          {
            name: '会员数量',
            type: 'bar',
            data: values,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' },
              ],
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }],
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },

    getDate(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getMonth(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      }
    },
    fastDate(is) {
      var myDate = new Date(
        new Date().getTime() - 1000 * 60 * 60 * 24 * 31 * 12
      );
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getList() {
      const shop_id = this.formInline.id;
      const data = {
        shop_id,
        indicators: [
          //支付
          {
            value_type: 'wechat_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          {
            value_type: 'ali_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          {
            value_type: 'member_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          {
            value_type: 'added_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          // 总销售额
          {
            value_type: 'total_sale',
            date_type: 'day',
            is_date_range: false,
            date: this.getDate(true),
          },
          {
            value_type: 'total_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          {
            value_type: 'total_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.fastDate(),
          },
          // 客户量
          {
            is_date_range: false,
            value_type: 'client_stat',
            date_type: 'day',
            date: this.getDate(true),
          },
          {
            is_date_range: false,
            value_type: 'client_stat',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'client_stat',
            date_type: 'month',
            date: this.fastDate(),
          },
          {
            is_date_range: true,
            value_type: 'client_stat',
            date_type: 'day',
            date_to: this.getDate(true),
            date_from: this.fastDate(true),
          },
          {
            is_date_range: true,
            value_type: 'member_stat',
            date_type: 'day',
            date_to: this.getDate(true),
            date_from: this.fastDate(true),
          },
          // 客单均价
          {
            is_date_range: false,
            value_type: 'per_client_sale',
            date_type: 'day',
            date: this.getDate(true),
          },
          // 充值金额
          {
            is_date_range: false,
            value_type: 'prepay_sale',
            date_type: 'day',
            date: this.getDate(true),
          },
          {
            is_date_range: false,
            value_type: 'prepay_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'prepay_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          // 订单量
          {
            is_date_range: false,
            value_type: 'order_stat',
            date_type: 'day',
            date: this.getDate(true),
          },
          {
            is_date_range: false,
            value_type: 'order_stat',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'order_stat',
            date_type: 'month',
            date: this.fastDate(),
          },
          //会员余额
          {
            is_date_range: false,
            value_type: 'member_total_balance',
            date_type: 'accumulate',
            date: this.getDate(),
          },
          //会员数量
          {
            is_date_range: false,
            value_type: 'member_stat',
            date_type: 'accumulate',
            date: this.getDate(),
          },
          //累计订单数量
          {
            is_date_range: false,
            value_type: 'order_stat',
            date_type: 'accumulate',
            date: this.getDate(),
          },
          //菜品数量
          {
            is_date_range: false,
            value_type: 'dish_stat',
            date_type: 'accumulate',
            date: this.getDate(),
          },
          //营业统计
          {
            value_type: 'total_sale',
            date_type: 'day',
            is_date_range: true,
            date_to: this.getDate(true),
            date_from: this.fastDate(true),
          },
        ],
      };
      const url = this.$userList.show_indicator;
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
    },
    setDatalist() {
      const data = {};
      this.datalist.map((item) => {
        if (item.indicator.date) {
          data[
            item.indicator.value_type +
              '_' +
              item.indicator.date_type +
              '_' +
              item.indicator.date
          ] =
            (item.value && item.value.total_price / 100) ||
            (item.value && item.value.count) ||
            0;
        } else {
          data[item.indicator.value_type + '_' + item.indicator.date_type] =
            item.total_price || item.value || item.count;
        }
      });
      this.total =
        (data['wechat_sale_month_' + this.getDate()] || 0) +
        (data['ali_sale_month_' + this.getDate()] || 0) +
        (data['member_sale_month_' + this.getDate()] || 0);
      this.topValue = data;
      console.log('data: ', data);
      this.drawLine();
      this.drawLines();
    },
    getDateTop() {
      this.getList();
    },
    handleChange(val) {},
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
}
.back {
  width: 100%;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295);
  box-sizing: border-box;
  background: #fff;
  padding: 0 10px;
  border-radius: 5px;
}
.back_s {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  padding: 20px 10px;
}
.back_s_name {
  font-size: 16px;
  width: 100%;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.flex_center {
  margin-bottom: 10px;
}
.name_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.purple_a {
  background: #17a2b7;
}
.purple_b {
  background: #27a844;
}
.purple_c {
  background: #fec107;
}
.purple_d {
  background: #dc3546;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-bottom: 10px !important;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fcfa;
}
.top_item_s {
  box-sizing: border-box;
  padding: 10px 10px;
  height: 150px;
  color: #fff;
  position: relative;
}
.item_click_s {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.1);
  font-size: 12px;
}
.item_value_s {
  font-size: 30px;
  line-height: 36px;
  font-weight: 600;
  width: 100%;
  text-align: left;
}
.item_name_s {
  font-size: 16px;
  width: 100%;
  text-align: left;
  margin-top: 10px;
}
.istopflex {
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.shujuflex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.shujuflex_a {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #26a345;
  display: none;
}
.shujuflex_b {
  font-size: 14px;
  line-height: 25px;
}
.shujuflex_c {
  font-size: 14px;
  line-height: 25px;
}
.shujuflex_page {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0;
}
.right_valur {
  width: 100%;
  height: 90px;
  margin-bottom: 10px;
  background: #fec107;
  display: flex;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 20px;
  align-items: center;
}
.leftIcon {
  font-size: 30px;
}
.right_valur_name {
  margin-left: 10px;
}
</style>
